module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_10-9d66205a4d4faee62c42e7ecd37a5a3f.jpg";